export const getBackendURL = () => process.env.REACT_APP_BACKEND_URL;
export const getMsalAuthClientId = () => process.env.REACT_APP_AZURE_CLIENT_ID;
export const getMsalAuthTenantId = () => process.env.REACT_APP_AZURE_TENANT_ID;
export const getMsalAuthRedirectUrl = () => process.env.REACT_APP_AZURE_REDIRECT_URL;
export const getApiUrl = () => process.env.REACT_APP_BACKEND_URL; 